import React from 'react'

const Content1 = () => {
    return (
        <div className='whole_container'>
            <div className='content_logo'>
                <img className='image_name' src='./logo1.png'></img>
                <span className='content_title'>EduCode</span>
                <a className='hlink' href=''>Sponsored.</a>              

            </div>
            <div className='content_head'>Beginner to Advanced courses in JavaScript, HTML/CSS and Python</div>
            <img className='cont1_img' src='./labtop.jpg'></img>
            <div className='img_Detail'>
                <a className='imglink' href=''>EDUCODE.ORG</a>
                <span className='mainheading'>SPARK THEIR CURIOUS</span>
                <span>start their coding journey today!</span>
            </div>
            <div className="comment_section">
            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
            <i class="fa fa-heart" aria-hidden="true"></i>
            <i class="fa fa-meh-o" aria-hidden="true"></i>
            <span className='members'>170</span>
            <span className='many_C'>4 commands,2 shares
            </span>
            <div className='like_boundry'>
            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
            <span className='like'>Like</span>
            <i class="fa fa-comment-o" aria-hidden="true"></i>
            <span className='like'>Command</span>
            <i class="fa fa-share" aria-hidden="true"></i>
            <span className='like'>Share</span>
            </div>
            </div>
            
        </div>
    )
}

export default Content1
